import { pipe } from 'ramda';
function convertAddressToString(address, countryName) {
  var doConvert = pipe(function (a) {
    return a.toJS();
  }, function (a) {
    return [a.department, a.subDepartment, joinTruthyValuesWithDelimiter(' ')([a.buildingNumber, a.street]), a.town, a.county, countryName || a.country, a.postcode];
  }, joinTruthyValuesWithDelimiter('\n'));
  return doConvert(address);
}
function joinTruthyValuesWithDelimiter(delimiter) {
  return function (items) {
    return items.filter(function (x) {
      return !!x;
    }).join(delimiter);
  };
}
export { convertAddressToString };